import { AppAvailabilityFeatureConfigSchema, type AppAvailabilityFeatureConfig } from '@school-journey/shared-types'

import type { ScreenFeatureEntry } from './entry'

/**
 * Global `app-availability` (the school kill switch).
 *
 * absentIsEmpty: no row carries it unless a school was switched off: the
 * fleet-default GLOBAL_FEATURE_CONFIGS row has none, and 0 of 33 school rows do
 * (read-only production query, `SystemConfiguration`, 2026-10-02).
 *
 * Fallback: `appDisabled: false`. Every reader treats absent as available
 * (`apps/mobile/src/services/session/resolve-school-unavailable.ts:51`,
 * `apps/backend/src/services/config/school-app-availability.ts:227`).
 */
export const appAvailability: ScreenFeatureEntry<'global', 'app-availability', AppAvailabilityFeatureConfig> = {
  resource: 'global',
  wireName: 'app-availability',
  schema: AppAvailabilityFeatureConfigSchema,
  writeMode: 'sparse',
  absentIsEmpty: true,
  fallback: {
    appDisabled: false
  }
}
